import React from 'react'
import ConnectorLogo from './ConnectorLogo'
import Style from './connectorCard.module.css'

export const CARD_STATE = {
    IDLE: 'idle',
    SELECTED: 'selected',
    COMPATIBLE: 'compatible',
    MUTED: 'muted'
}

const actionLabel = (system, state) => {
    if (!system.isAvailable) return 'Coming soon'
    if (state === CARD_STATE.SELECTED) return 'Selected'
    if (state === CARD_STATE.COMPATIBLE) return 'Add to integration'
    return 'Select'
}

const ConnectorCard = ({ system, state = CARD_STATE.IDLE, isInAccount, compatibleWith, showDescription = true, onSelect }) => {
    const isSelected = state === CARD_STATE.SELECTED

    return (
        <button
            type="button"
            className={[Style.card, Style[`state_${state}`], system.isAvailable ? '' : Style.unavailable].join(' ')}
            aria-pressed={isSelected}
            disabled={!system.isAvailable}
            onClick={() => onSelect(system)}
        >
            <span className={Style.head}>
                <ConnectorLogo src={system.image} name={system.shortName} />
                <span className={Style.titles}>
                    <span className={Style.name} title={system.name}>{system.name}</span>
                    <span className={Style.vendor}>{system.vendor || system.shortName}</span>
                </span>
                {isSelected ? <i className={`uil-check-circle ${Style.check}`} aria-hidden="true" /> : null}
            </span>

            {showDescription ? <span className={Style.description}>{system.description}</span> : null}

            <span className={Style.tags}>
                <span className={`${Style.tag} ${Style[`tag_${system.category}`] || ''}`}>{system.categoryLabel}</span>
                {system.isFeatured ? <span className={`${Style.tag} ${Style.tag_featured}`}>Featured</span> : null}
                {isInAccount ? <span className={`${Style.tag} ${Style.tag_owned}`}>In your account</span> : null}
                {state === CARD_STATE.COMPATIBLE && compatibleWith
                    ? <span className={`${Style.tag} ${Style.tag_compatible}`}>Works with {compatibleWith}</span>
                    : null}
            </span>

            <span className={Style.action}>
                {actionLabel(system, state)}
                {system.isAvailable && !isSelected ? <i className="uil-arrow-right" aria-hidden="true" /> : null}
            </span>
        </button>
    )
}

export default ConnectorCard
